import React from 'react';
import { Phone, MapPin, Clock, CheckCircle } from 'lucide-react';
import { firmInfo } from '../mock';
import DeftForm from '../components/DeftForm';

const Contact = () => {
  return (
    <div style={{ marginTop: '70px' }}>
      {/* Hero Section */}
      <section style={{
        background: 'var(--bg-card)',
        padding: '80px 0',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 className="heading-1" style={{ color: 'var(--brand-primary)', marginBottom: '24px' }}>
            Contact Us
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
            Get in touch with our experienced legal team. We're here to help you get the compensation you deserve.
          </p>
        </div>
      </section>

      {/* Contact Info & Form Section */}
      <section style={{ padding: '96px 0', background: 'var(--bg-page)' }}>
        <div className="container">
          <div className="responsive-grid-contact">
            {/* Contact Information */}
            <div>
              <h2 className="heading-3" style={{ color: 'var(--brand-primary)', marginBottom: '32px' }}>
                Get In Touch
              </h2>
              <p style={{ color: 'var(--text-secondary)', marginBottom: '40px', lineHeight: '1.6' }}>
                Reach out to us today for a free consultation. We're available to answer your questions and discuss your case.
              </p>

              {/* Contact Details */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
                {/* Phone */}
                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                  <div style={{
                    width: '50px',
                    height: '50px',
                    background: 'var(--brand-primary)',
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <Phone size={24} color="var(--text-inverse)" />
                  </div>
                  <div>
                    <h4 style={{ color: 'var(--text-white)', marginBottom: '8px', fontWeight: '600' }}>
                      Phone
                    </h4>
                    <a
                      href={`tel:${firmInfo.phone}`}
                      style={{
                        color: 'var(--brand-primary)',
                        textDecoration: 'none',
                        fontSize: '1.1rem',
                        fontWeight: '600'
                      }}
                    >
                      {firmInfo.phone}
                    </a>
                  </div>
                </div>

                {/* Address */}
                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                  <div style={{
                    width: '50px',
                    height: '50px',
                    background: 'var(--brand-primary)',
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <MapPin size={24} color="var(--text-inverse)" />
                  </div>
                  <div>
                    <h4 style={{ color: 'var(--text-white)', marginBottom: '8px', fontWeight: '600' }}>
                      Office Address
                    </h4>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                      {firmInfo.address.full}
                    </p>
                  </div>
                </div>

                {/* Hours */}
                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                  <div style={{
                    width: '50px',
                    height: '50px',
                    background: 'var(--brand-primary)',
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <Clock size={24} color="var(--text-inverse)" />
                  </div>
                  <div>
                    <h4 style={{ color: 'var(--text-white)', marginBottom: '8px', fontWeight: '600' }}>
                      Office Hours
                    </h4>
                    <p style={{ color: 'var(--text-secondary)' }}>
                      {firmInfo.hours}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form - DeftForm Embed */}
            <div className="form-container">
              <h3 className="heading-3" style={{ color: 'var(--brand-primary)', marginBottom: '24px' }}>
                Send Us a Message
              </h3>
              <DeftForm />

              {/* No Risk Guarantee */}
              <div style={{
                marginTop: '24px',
                padding: '20px',
                background: 'var(--bg-card)',
                borderRadius: '8px',
                border: '1px solid var(--brand-primary)'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                  <CheckCircle size={24} color="var(--brand-primary)" />
                  <strong style={{ color: 'var(--brand-primary)' }}>No Risk Guarantee</strong>
                </div>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', lineHeight: '1.6' }}>
                  This consultation is completely free with no obligation. We work on a contingency fee basis - you don't pay unless we win your case. Your information is confidential and protected by attorney-client privilege.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section style={{ padding: '0 0 96px 0', background: 'var(--bg-page)' }}>
        <div className="container">
          <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '32px', textAlign: 'center' }}>
            Find Our Office
          </h2>
          <div style={{
            borderRadius: '16px',
            overflow: 'hidden',
            border: '2px solid var(--border-light)',
            height: '450px'
          }}>
            <iframe
              src={firmInfo.mapUrl}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="LG Law Office Location"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
